import { graphql } from 'gatsby';
import { getKey } from '../../../helpers';

/**
 * Jobs Contact form definition
 * @param {Object} props of the widget
 * @param {Strign} locale of the widget
 * @returns {Object}
 */
export default function jobsContactForm(props, locale) {
  return {
    content: getKey(props, `content_${locale}`),
    title: getKey(props, `title_${locale}`),
    endPoint: getKey(props, 'endpoint'),
    errorLabel: getKey(props, `error_${locale}`),
    successLabel: getKey(props, `success_${locale}`),
    locale,
  };
}

/**
 * GraphQL query
 */
export const query = graphql`
  fragment JobsContactForm on StrapiWidgetrels {
    jobscontactform {
      key: id
      title_en
      title_es
      content_en
      content_es
      error_en
      error_es
      success_en
      success_es
      endpoint
      widgetPosition
    }
  }
`;
